import React from 'react';
import classNames from 'classnames';
import {Button, ButtonPriority, PaddingModes} from '@wix/wix-ui-tpa/cssVars';
import {classes, cssStates} from './CategoryListItem.st.css';
import {ICategoryListItem} from '../../../../types/category';
import {useCategories} from '../../../hooks/useCategories';
import {CategoryListLayout, Experiments} from '../../../../constants';
import {useStyles} from '@wix/tpa-settings/react';
import {useStylesParams} from '../../../../stylesParamsContext';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';

type CategoryListItemProps = {
  dataHook?: string;
  className?: string;
  category: ICategoryListItem;
  text: string;
};

export const CategoryListItem: React.FC<CategoryListItemProps> = ({
  dataHook,
  category,
  text,
  className,
}: CategoryListItemProps) => {
  const {currentCategory, navigateToCategory} = useCategories();
  const isActive = currentCategory.id === category.id;
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const isFixCategoryUnderlineOnHoverEnabled = experiments.enabled(Experiments.FixCategoryUnderlineOnHover);
  const verticalCategoryList =
    styles.get(stylesParams.gallery_categoryListLayout) === CategoryListLayout.Vertical && !isMobile;

  return (
    <li className={className}>
      <Button
        as="a"
        paddingMode={PaddingModes.explicitPaddings}
        priority={ButtonPriority.secondary}
        data-hook={dataHook}
        className={classNames(
          {
            [classes.verticalRoot]: verticalCategoryList,
            [classes.horizontalRoot]: !verticalCategoryList,
            [classes.horizontalRootDisabled]: !verticalCategoryList && !isFixCategoryUnderlineOnHoverEnabled,
          },
          cssStates({activeCategory: isActive})
        )}
        wrapContent={verticalCategoryList}
        href={category.categoryUrl}
        onClick={() => navigateToCategory(category.id)}>
        {text}
      </Button>
    </li>
  );
};
